import automationApi from '../api/AutomationApi';
import { EntityWithStatus, ProjectMember } from '../model/entities';

class AutomationService {
    /**
     * Syncrhonizes the project user role services in the BIM360 platform.
     * @param result - the imported project members
     * @param hubId - the hub id
     */
    synchronizeProjectUserRoleServices = async (result: EntityWithStatus<ProjectMember>[], hubId: string) => {
        try {
            const projectMembers: ProjectMember[] = result
                .filter((e) => e.status.type === 'OK' && e.entity.email)
                .map((e) => e.entity);
            await automationApi.synchronizeProjectUserRoleServices(projectMembers, hubId);
        } catch (error) {
            // error not handled
        }
    };
}

const automationService: AutomationService = new AutomationService();
export default automationService;
